export default "__VITE_ASSET__CvJv_90E__"